import React, { Component, Fragment } from 'react';
import { FaPlusCircle } from 'react-icons/fa';

import Fields from './Fields';

import Content from './styles';

class Specification extends Component {
  state = {
    fields: [],
    fieldFocused: new Map(),
    fieldMapError: new Map(),
    fieldError: false,
  }

  componentDidMount = () => {
    const { currentMaterial } = this.props;

    if (currentMaterial) {
      this.setState({ fields: currentMaterial.description || [] });
    }
  }

  handleSubmit = async () => {
    const { fields } = this.state;

    this.setState({
      fieldMapError: new Map(),
      fieldError: false,
    });

    if (fields.length > 0) {
      await this.validateInputs();

      const { fieldError } = this.state;

      if (!fieldError) {
        return {
          specification: true,
          error: false,
          description: fields,
        };
      }

      return { specification: true, error: true };
    }

    return { specification: false };
  }

  validateInputs = () => {
    const { fields } = this.state;

    for (let i = 0; i < fields.length; i += 1) {
      if (fields[i].label.length === 0 || fields[i].desc.length === 0) {
        this.setState({ fieldError: true });
        this.itemError(i);
      }
    }
  }

  addItem = () => {
    this.setState(state => ({
      fields: [
        ...state.fields,
        { label: '', desc: '' },
      ],
    }));
  };

  deleteItem = (index) => {
    const { fields, fieldMapError } = this.state;

    fields.splice(index, 1);

    if (fieldMapError.get(index)) {
      fieldMapError.delete(index);

      this.setState({ fieldMapError });
    }

    this.setState({ fields });
  };

  handleInputChange = (type, value, index) => {
    const { fields } = this.state;

    if (type === 'label') fields[index].label = value;
    else fields[index].desc = value;

    this.setState({ fields });
  };

  itemError = (id) => {
    this.setState((state) => {
      const fieldMapError = new Map(state.fieldMapError);
      fieldMapError.set(id, !fieldMapError.get(id));
      return { fieldMapError };
    });
  }

  onFocus = (type, id) => {
    this.setState(() => {
      const fieldFocused = new Map();
      fieldFocused.set(id, { type, value: !fieldFocused.get(id) });
      return { fieldFocused };
    });
  }

  onBlur = () => {
    this.setState(() => {
      const fieldFocused = new Map();
      return { fieldFocused };
    });
  }

  render() {
    const { fields } = this.state;

    return (
      <Fragment>
        {this.props.active && (
          <Content>
            {fields.map((item, index) => (
              <Fields
                key={index.toString()}
                id={index}
                item={item}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                focused={this.state.fieldFocused.get(index)}
                error={!!this.state.fieldMapError.get(index)}
                handleInputChange={this.handleInputChange}
                deleteItem={this.deleteItem}
              />
            ))}
            <button type="button" className="add-btn" onClick={this.addItem}>
              <FaPlusCircle className="fa fa-plus-circle" />
              <span>Adicionar item</span>
            </button>
          </Content>
        )}
      </Fragment>
    );
  }
}

export default Specification;
